import React from 'react'
import PropTypes from 'prop-types'

import { numberMustBeBetween } from '../../../../utils/customPropTypes'

function Slider({ ariaLabelId, disabled, min, max, onChange, initialValue }) {
  // In order for the provided min value to correspond to leftmost location of the slider,
  // and max to the rightmost, need to adjust the value provided by event

  // PropTypes definition inside component render fn so checks can be performed dynamically
  // on min, max, and initialValue
  Slider.propTypes = {
    ariaLabelId: PropTypes.string.isRequired,
    max: numberMustBeBetween(min, null),
    min: numberMustBeBetween(null, max),
    // changeDurationHandler: PropTypes.func.isRequired,
    initialValue: numberMustBeBetween(min - 1, max + 1),
  }

  return (
    <div className="slider">
      <input
        aria-labelledby={ariaLabelId}
        defaultValue={initialValue - min}
        disabled={disabled}
        type="range"
        min="0"
        max={max - min}
        onChange={onChange}
        autoFocus
        id="volume_control"
      />
    </div>
  )
}

export default Slider
